export default {
  title1: '联系方式一：通过以下两种联系方式与我们联系',
  contactPhone: '联系电话：0086512-6813-8573',
  contactMail: '联系邮箱：fanhan@fanhantech.com',
  title2: '联系方式二：在线填写邮件（适用于拥有PC邮箱客户端的用户）',
  name: '姓名',
  mail: '邮箱',
  phone: '电话号码',
  message: '任务描述',
  send: '使用客户端发送',
  js: {
    name: '姓名',
    mail: '邮箱',
    phone: '联系电话',
    message: '任务描述',
    title: '定制任务',
    rule: '请确认信息是否填写完毕'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh/sendmail.js